import { render, staticRenderFns } from "./UserCenterWareinfo.vue?vue&type=template&id=01b4ac7c&scoped=true"
import script from "./UserCenterWareinfo.vue?vue&type=script&lang=js"
export * from "./UserCenterWareinfo.vue?vue&type=script&lang=js"
import style0 from "./UserCenterWareinfo.vue?vue&type=style&index=0&id=01b4ac7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01b4ac7c",
  null
  
)

export default component.exports